export default class Perfil {

    constructor(numero, nome, nomeSistema=null) {
        this.numero = parseInt(numero);
        this.nome = nome;
        this.nomeSistema = nomeSistema;
    }

    toString(){
        return  `${this.numero} - ${this.nome}`;
    }

}